import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@totalsoft/rocket-ui';
import MenuIcon from '@mui/icons-material/Menu';
import { NavPillsBoxContainer } from 'components/common/Styles';
import { useTranslation } from 'react-i18next';
import LeasingIncomeSchemaEventsContainer from './events/LeasingIncomeSchemaEventsContainer';
import LeasingIncomeSchemaPropertiesContainer from './properties/LeasingIncomeSchemaPropertiesContainer';
import LeasingIncomeSchemaXPartnersContainer from './partners/LeasingIncomeSchemaXPartnersContainer';
import LeasingIncomeSchemaXGroupsContainer from './groups/LeasingIncomeSchemaXGroupsContainer';
import NavPillsWithPrompt from 'features/common/dirtyInfo/components/NavPillsWithPrompt';

const LeasingIncomeSchemaDetailsContainer = ({ id }) => {
  const { t } = useTranslation();

  return (
    <Card icon={MenuIcon}>
      <NavPillsBoxContainer panelTopMargin={1} panelOverflow='visible'>
        <NavPillsWithPrompt
          fullWidth
          tabs={[
            {
              label: t('LeasingIncomeSchema.EventsTab'),
              content: <LeasingIncomeSchemaEventsContainer id={id} />
            },
            {
              label: t('LeasingIncomeSchema.PartnersTab'),
              content: <LeasingIncomeSchemaXPartnersContainer id={id} />
            },
            {
              label: t('LeasingIncomeSchema.GroupsTab'),
              content: <LeasingIncomeSchemaXGroupsContainer id={id} />
            },
            {
              label: t('LeasingIncomeSchema.PropertiesTab'),
              content: <LeasingIncomeSchemaPropertiesContainer id={id} />
            }
          ]}
        />
      </NavPillsBoxContainer>
    </Card>
  );
};

LeasingIncomeSchemaDetailsContainer.propTypes = {
  id: PropTypes.number
};

export default LeasingIncomeSchemaDetailsContainer;
